if (!customElements.get('upsells-products')) {
  customElements.define(
    'upsells-products',
    class UpsellsProducts extends HTMLElement {
      constructor() {
        super()
        this.locale = this.dataset.locale
        this.currency = this.dataset.currency

        this.checkboxs = this.querySelectorAll('.upsells__checkbox input')
        this.counter = this.querySelector('.upsells__count .count')
        this.total = this.querySelector('.upsells__total')
        this.form = this.querySelector('.upsells__form')
        this.submitButtonCounter = this.querySelector('.upsells__submit .count')
        this.bottom = this.querySelector('.upsells__bottom')
        this.cartNotification = document.querySelector('cart-notification');

        this.checkboxs.forEach(checkbox => {
          checkbox.addEventListener('change', this.selectedProducts.bind(this))
        })

        this.form.addEventListener('submit', this.onSubmit.bind(this))

        // Mostrar "Leer más" solo si hay truncado (solo en móviles)
        if (window.innerWidth < 768) {
          const advice = this.querySelector('#upsellsAdvice');
          const toggle = this.querySelector('#upsellsToggle');

          if (advice && toggle) {
            const lineHeight = parseFloat(getComputedStyle(advice).lineHeight) || 24;
            const full = advice.cloneNode(true);
            full.style.cssText = `
              position:absolute;visibility:hidden;height:auto;display:block;
              -webkit-line-clamp:unset;-webkit-box-orient:vertical;white-space:normal;
              width:${advice.offsetWidth}px;
            `;
            document.body.appendChild(full);

            if (full.offsetHeight > lineHeight * 3) {
              toggle.style.display = 'inline-block';
            } else {
              toggle.style.display = 'none';
            }

            document.body.removeChild(full);
          }
        }
      }

      selectedProducts() {
        let upsells_count = 0
        let upsells_total = 0
        this.checkboxs.forEach(checkbox => {
          if (checkbox.checked) {
            upsells_count++
            upsells_total += parseFloat(checkbox.dataset.price)
          }

        })

        this.counter.innerHTML = upsells_count
        this.submitButtonCounter.innerHTML = upsells_count
        this.total.innerHTML = this.formatPrice(upsells_total)

        if (upsells_count == 0) {
          this.bottom.classList.add('hidden')
        } else {
          this.bottom.classList.remove('hidden')
        }
      }

      onSubmit(event) {
        event.preventDefault()

        var formData = new FormData(this.form)
        var items = []

        formData.forEach(function (value) {
          items.push({
            'id': value,
            'quantity': 1
          })
        })

        formData = {
          items,
          sections: 'cart-icon-bubble,cart-drawer,cart-notification-product'
        }

        const route = window.Shopify.routes.root ?
          window.Shopify.routes.root + 'cart/add.js' :
          window.Shopify.routes.cart_url + '/add.js'

        fetch(route, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(data => {
            const itemsKeys = data.items.map(item => item.key)
            this.renderSections(data.sections, itemsKeys)
            document.getElementById('cart-drawer').classList.remove('is-empty')
            this.cartNotification.open();
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }

      renderSections(sections, itemsKeys) {
        for (let sectionId in sections) {
          let section = document.getElementById(sectionId)
          let sectionHtml = sections[sectionId]
          if (section && sectionHtml) {
            if (sectionId == 'cart-drawer') {
              const tempElement = document.createElement('div');
              tempElement.innerHTML = sectionHtml;

              document.getElementById('CartDrawer-Header').innerHTML = tempElement.querySelector('#CartDrawer-Header').innerHTML
              document.getElementById('CartDrawer-Contents').innerHTML = tempElement.querySelector('#CartDrawer-Contents').innerHTML
              document.getElementById('CartDrawer-Footer').innerHTML = tempElement.querySelector('#CartDrawer-Footer').innerHTML
            } else {
              section.innerHTML = sectionHtml

              if (sectionId == 'cart-notification-product') {
                document.querySelectorAll('[id^="cart-notification-product-"]').forEach(item => {
                  if (!itemsKeys.includes(item.dataset.key)) {
                    item.remove()
                  }
                })
              }
            }
          }
        }
      }

      formatPrice(amount) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        }).format(amount / 100).replace('.', ',')
      }

    }
  )
}
